import React, {Component} from "react";
import SportIcon from "../../../components/SportIcon";
import {Link} from "react-router-dom";

class Sport extends Component {
	render() {
		const {sport, children} = this.props;

		return (
			<div key={`line-select-sport-${sport.id}`}>
				<div className="events__header">
					<div className="events__header__sportname">
							<span className="sport-icon small green events__header__sporticon">
								<SportIcon sportId={sport.id}/>
							</span>
						<span>&nbsp;<Link to={`/line-sports/${sport.id}`}>{sport.name}</Link></span>
					</div>
				</div>
				<div className="events">
					<div className="events__table table-div">
						{children}
					</div>
				</div>
			</div>
		);
	}
}

export default Sport;


// WEBPACK FOOTER //
// ./src/app/pages/LineSelect/modules/Sport.js